import rules from "@/utils/rules";
export default [
    {
        name: 'Фамилия, имя, отчество',
        type: 'input',
        typeInput: 'text',
        disabled: false,
        rules: [rules.required, rules.counter, rules.fam],
        dataField: 'fio',
    },
    {
        name: 'Должность',
        type: 'input',
        disabled: false,
        rules: [rules.required, rules.counter3, rules.dolg, rules.fam],
        dataField: 'position',
    },
    {
        name: 'Электронная почта',
        type: 'input',
        typeInput: 'text',
        rules: [rules.email],
        disabled: false,
        dataField: 'email',
    },

    {
        name: 'Рабочий телефон (с кодом города)',
        type: 'telephone',
        cols: 8,
        disabled: false,
        dataField: 'workPhoneNumber',
    },
    {
        name: 'Добавочный номер',
        type: 'input',
        cols: 4,
        disabled: false,
        rules: [],
        dataField: 'workPhoneExtension',
    },

    {
        name: 'Мобильный телефон',
        type: 'telephone',
        cols: 8,
        disabled: false,
        dataField: 'personalPhoneNumber',
    },
    {
        name: 'Добавочный номер',
        type: 'input',
        cols: 4,
        disabled: false,
        rules: [],
        dataField: 'personalPhoneExtension',
    },
]
